const THREE = require("three");
let {
  Water
} = require("./Water.js");
var v6046 = new THREE.TextureLoader();
const vP73592 = require("./utils.js");
var vA320 = [32, 64, 128, 256, 1024, 2048];
class Ocean extends THREE.Object3D {
  static fromConfig(p7360, p7361) {
    return new Ocean(p7361, p7360.ocCol, p7360.ocOpac, p7360.ocDist, p7360.ocSpd, p7360.ocYOff, p7360.ocRefRes, p7360.ocW, p7360.ocL);
  }
  constructor(p7362, p7363, p7364, p7365, p7366, p7367, p7368, p7369, p7370) {
    super();
    this.col = vP73592.isHexColor(p7363) ? p7363 : "#001e0f";
    this.opac = vP73592.limitMM(p7364, 0, 1);
    this.dist = vP73592.limitMM(p7365, 0, 10);
    this.speed = vP73592.limitMM(p7366, 0.1, 5);
    this.yOff = vP73592.limitMM(p7367, -1000, 1000);
    this.refRes = vA320[vP73592.limitMM(p7362.reflectionQuality || p7368, 1, 6) - 1];
    this._width = vP73592.limitMM(p7369, 100, 20000);
    this._length = vP73592.limitMM(p7370, 100, 20000);
    let v6047 = new THREE.PlaneGeometry(this._width, this._length);
    this.baseMesh = new Water(v6047, {
      textureWidth: this.refRes,
      textureHeight: this.refRes,
      waterNormals: v6046.load(vP73592.assetsUrl("/textures/water_0.png"), function (p7371) {
        p7371.wrapS = p7371.wrapT = THREE.RepeatWrapping;
      }),
      alpha: p7364,
      sunDirection: p7362.skyLight ? p7362.skyLight.position.clone().normalize() : new THREE.Vector3(),
      sunColor: p7362.skyLight ? p7362.skyLight.color.getHex() : 16777215,
      waterColor: this.col,
      distortionScale: this.dist,
      fog: true
    });
    this.baseMesh.rotation.x = -Math.PI / 2;
    this.baseMesh.position.y = p7367;
    this.baseMesh.material.opacity = p7364;
    this.baseMesh.material.transparent = p7364 != 1;
    this.add(this.baseMesh);
  }
  update(p7372) {
    this.baseMesh.material.uniforms.time.value += p7372 / 1000 * this.speed;
  }
}
Ocean.CONFIG_PROPS = ["ocCol", "ocOpac", "ocDist", "ocSpd", "ocYOff", "ocRefRes", "ocW", "ocL"];
module.exports = Ocean;